// import React from 'react';
// import './Library.css';
// import LibraryNavbar from '../../components/Library/LibraryNavbar';
// import LibrarySlider from '../../components/Library/LibrarySlider';
// import LibraryIntroduction from '../../components/Library/LibraryIntroduction';
// import LibraryVideoSection from '../../components/Library/LibraryVideoSection';
// import LibraryStatistics from '../../components/Library/LibraryStatistics';
// import LibraryGallery from '../../components/Library/LibraryGallery';
// import Footer from '../../components/Homepage/Footer/Footer';

// const Library = () => {
//   React.useEffect(() => {
//     // Set page title
//     document.title = 'Central Library - Rayalaseema University';
    
//     // Scroll to top when component mounts
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <div id="library-main-page">
//       {/* Library-specific Navigation */}
//       <LibraryNavbar />
      
//       {/* Hero Slider Section */}
//       <LibrarySlider />
      
//       {/* Library Introduction */}
//       <LibraryIntroduction />
      
//       {/* Video Section with VC and Head of Library */}
//       <LibraryVideoSection />
      
//       {/* Statistics Section */}
//       <LibraryStatistics />
      
//       {/* Gallery Section */}
//       <LibraryGallery />
      
//       {/* Footer */}
//       <Footer />
//     </div>
//   );
// };

// export default Library;
import React, { useEffect, useState } from "react"
import "./Library.css"

import LibrarySlider from "../../components/Library/LibrarySlider"
import LibraryIntroduction from "../../components/Library/LibraryIntroduction"
import LibraryVideoSection from "../../components/Library/LibraryVideoSection"
import LibraryStatistics from "../../components/Library/LibraryStatistics"
import LibraryGallery from "../../components/Library/LibraryGallery"
import Footer from "../../components/Homepage/Footer/Footer"
import Navbar from "../../components/Homepage/Navbar/Navbar"
import Staff from "./Staff"


const Library = () => {
  const [activeTab, setActiveTab] = useState("library-about")

  useEffect(() => {
    document.title = "Central Library - Rayalaseema University"
    window.scrollTo(0, 0)
  }, [])

  const quickLinks = [
    { name: "HOME", id: "library-about" },
    { name: "OPAC", id: "library-opac" },
    { name: "Committee", id: "library-committee" },
    { name: "e-Resources", id: "library-eresources" },
    { name: "e-Journals", id: "library-ejournals" },
    { name: "Drilbit", id: "library-drillbit" },
    { name: "Guidelines", id: "library-guidelines" },
    { name: "Open Access", id: "library-openaccess" },
    { name: "Staff", id: "library-staff" }
  ]

  return (
    <>
    <Navbar />
    <div id="library-main-page">

      {/* ===== HERO SLIDER ===== */}
      <LibrarySlider />

      <div className="library-layout">

        {/* ===== QUICKLINK SIDEBAR ===== */}
        <aside className="library-sidebar">
          <h3>Quick Links</h3>
          {quickLinks.map(link => (
            <button
              key={link.id}
              className={`sidebar-link ${activeTab === link.id ? "active" : ""}`}
              onClick={() => setActiveTab(link.id)}
            >
              {link.name}
            </button>
          ))}
        </aside>

        {/* ===== MAIN CONTENT ===== */}
        <main className="library-content">

          {/* ===== HOME / ABOUT TAB ===== */}
          {activeTab === "library-about" && (
            <>
             <LibraryVideoSection />
              <LibraryIntroduction />
             
              <LibraryStatistics />
            
              <LibraryGallery />
            </>
          )}

          {/* ===== OPAC ===== */}
          {activeTab === "library-opac" && (
            <section className="library-section">
              <h2>OPAC</h2>
              <p>
                Online Public Access Catalogue (OPAC) provides access to the
                library’s collection including books, journals and digital resources.
              </p>
            </section>
          )}

          {/* ===== COMMITTEE ===== */}
          {activeTab === "library-committee" && (
            <section className="library-section">
              <h2>Library Committee</h2>
              <p>
                The Library Committee oversees policies, development and effective
                utilization of library resources.
              </p>
            </section>
          )}

          {/* ===== E-RESOURCES ===== */}
          {activeTab === "library-eresources" && (
            <section className="library-section">
              <h2>e-Resources</h2>
              <p>
                Access to subscribed databases, e-books, online journals and digital repositories.
              </p>
            </section>
          )}

          {/* ===== E-JOURNALS ===== */}
          {activeTab === "library-ejournals" && (
            <section className="library-section">
              <h2>e-Journals</h2>
              <p>
                National and international peer-reviewed journals available for students and faculty.
              </p>
            </section>
          )}

          {/* ===== DRILBIT ===== */}
          {activeTab === "library-drillbit" && (
            <section className="library-section">
              <h2>Drilbit</h2>
              <p>
                Plagiarism detection tool for maintaining academic integrity.
              </p>
            </section>
          )}

          {/* ===== GUIDELINES ===== */}
          {activeTab === "library-guidelines" && (
            <section className="library-section">
              <h2>Library Guidelines</h2>
              <p>
                Rules and regulations for effective usage of library facilities.
              </p>
            </section>
          )}

          {/* ===== OPEN ACCESS ===== */}
          {activeTab === "library-openaccess" && (
            <section className="library-section">
              <h2>Open Access</h2>
              <p>
                Institutional repository and open access scholarly resources.
              </p>
            </section>
          )}

          {/* ===== STAFF ===== */}
          {activeTab === "library-staff" && (
            <section className="library-section">
              <Staff />
            </section>
          )}

        </main>
      </div>

      <Footer />
    </div>
    </>
  )
}

export default Library
